import React from "react";
import VillaOptions from "@/components/pages/VillaOptions";
import Areas from "@/components/pages/Areas";
import getServer from "@/utils/functions/function";

const Category = ({ data, RoutingAction }) => {
  return (
    <>
      {RoutingAction === "Index" && <VillaOptions data={data} />}
      {RoutingAction === "Destination" && <Areas data={data} />}
    </>
  );
};

export default Category;

export async function getServerSideProps(context) {
  return await getServer(context);
}
